
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.406 15.625H5.625V4.375h5.313a3.281 3.281 0 012.5 5.406 3.281 3.281 0 01-2.032 5.844zM7.5 13.75h3.894a1.408 1.408 0 00.994-2.4 1.407 1.407 0 00-.994-.412H7.5v2.812zm0-4.688h3.438a1.406 1.406 0 100-2.812H7.5v2.813z","fill":"#585858"}})])
          )
        }
      }
    